import React,{ Suspense, lazy, ReactFragment, ReactPortal, ReactChild, useState } from 'react'
import Loader from '../../Loading'
import { Tabs } from 'antd';
const { TabPane } = Tabs;

const Reservation = lazy(() => import('./Reservation'))

type propTypes = {
    isEditable: () => boolean
    cancelEditable: () => boolean
  }

const ReservationInformation = (props: propTypes) => {

    const [editionMode, setEditionMode] = useState<boolean>(false)
    const [categoryEnabled, setCategoryEnabled] = useState<string | number>()

    const isEditable = (category: string) => {
        setEditionMode(true)
        setCategoryEnabled(category)
    }

    const cancelEditable = () => {
        setCategoryEnabled('0')
        setEditionMode(false)
    }
    
    const Loading: () =>  boolean | ReactChild | ReactFragment | ReactPortal | null = () => {
        return (
        <Loader type="medium" />
        )
    }

    return (<>
        <Tabs defaultActiveKey="1">
        <TabPane
          tab="Reservation Information"
          key="1"
          disabled={editionMode && categoryEnabled !== '1'}
        >
          {
              <Suspense fallback={Loading()}>
                  <Reservation
                   isEditable={isEditable}
                   cancelEditable={cancelEditable} 
                  />
              </Suspense>
          }
        </TabPane>
      </Tabs>
    </>)
}

export default ReservationInformation